<template>
  <button
    class="icon-cart-btn"
    v-on:click="addToCartClick($event)"
    :disabled="isProductDisabled"
    :class="[iconCartColor, { 'disabled': isProductDisabled }]"
    data-testid="addToCart"
  >
    <i class="material-icons">shopping_cart</i>
  </button>
</template>

<script>
import config from 'config'
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import { notifications } from '@vue-storefront/core/modules/cart/helpers'
import focusClean from 'theme/components/theme/directives/focusClean'

export default {
  directives: { focusClean },
  data () {
    return {
      config,
      isAddingToCart: false,
      iconCartColor: ''
    }
  },
  props: {
    product: {
      required: true,
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    addToCartClick (e) {
      e.preventDefault();
      e.stopPropagation();
      this.addToCart(this.product)
    },
    async addToCart (product) {
      try {
        this.isAddingToCart = true
        const diffLog = await this.$store.dispatch('cart/addItem', { productToAdd: product })
        diffLog.clientNotifications.forEach(notificationData => {
          this.notifyUser(notificationData)
        })
      } catch (message) {
        this.notifyUser(notifications.createNotification({ type: 'error', message }))
      } finally {
        this.isAddingToCart = false
      }
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    }
  },
  computed: {
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  },
  mounted () {
    let catalog = this.$route.meta.category || this.product.catalog;
    if(catalog !== config.rootcategories.biuro) {
      this.iconCartColor = 'icon-cart-btn' 
    } else {
      this.iconCartColor = 'icon-cart-btn-office'
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/variables/typography';

.icon-cart-btn {
  background: $pink;
  color: #fff;
  font-size: $font-size-base;
  font-family: $font-roboto;
  width: 40px;
  height: 40px;
  border-radius: 22px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 0px;
  outline: none;
  box-shadow: none;

  &.disabled {
    background: $gray;
  }
}

.icon-cart-btn-office{
  background: $office-primary;
  color: #fff;
  font-size: $font-size-base;
  font-family: $font-roboto;
  width: 40px;
  height: 40px;
  border-radius: 22px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 0px;
  outline: none;
  box-shadow: none;

  &.disabled {
    background: $gray;
  }
}

</style>
